import React, { useEffect, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { buildBaseOption, buildChartTheme } from './chartTheme';

const DEFAULT_COLOR_KEYS = ['queued', 'autonomous', 'running'];

function BarChart({
  series = [],
  labels = [],
  height = 220,
  colorKeys = DEFAULT_COLOR_KEYS
}) {
  const wrapperRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const node = wrapperRef.current;
    const instance = chartRef.current?.getEchartsInstance?.();

    if (!node || !instance || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const observer = new ResizeObserver(() => instance.resize());
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const theme = buildChartTheme();
  const option = buildBaseOption(theme);

  option.xAxis.boundaryGap = true;
  option.xAxis.data = labels;
  option.series = series.map((entry, index) => {
    const color = theme.colors[colorKeys[index % colorKeys.length]] || theme.colors.queued;

    return {
      name: entry.name,
      type: 'bar',
      barMaxWidth: 18,
      data: entry.data,
      itemStyle: { color, borderRadius: [3, 3, 0, 0] }
    };
  });

  return (
    <div className="chart-wrapper" ref={wrapperRef} style={{ height }}>
      <ReactECharts
        ref={chartRef}
        option={option}
        style={{ height: '100%', width: '100%' }}
        notMerge
        lazyUpdate
      />
    </div>
  );
}

export default BarChart;
